import React from "react";

function Footer() {
    return (
        <div>
            <footer
                className="flex justify-evenly gap-4 text-start text-xs bg-gray-900 p-1 text-gray-500 
            "
            >
                <p className="font-semibold">Designed and Developed by William Timlin 2021</p>
                <p> Data collected from The Metropolitan Museum of Art Collection Api: https://metmuseum.github.io/</p>
            </footer>
        </div>
    );
}

export default Footer;
